import React, { useState, useEffect } from "react";
import TituloEscenario from "../titulo-escenario";
import TablaProyeccionesAP from "../tabla-proyecciones-ap";
import TerminosCondiciones from "../terminos-condiciones";
import BotonExpandir from "../boton-expandir";
import TextoDevolucion from "../texto-devolucion";
import styles from "./proyeccion-ap.module.css";
import * as Funciones from "../../../../utils/funciones";
import * as Constantes from "../../../../utils/constantes";

const ProyeccionAP = ({ producto, textosLegales }) => {
    const initialState = {
        proyecciones: [],
        expandido: false,
        montoDevolucion: producto.escenarios[0].proyecciones.length > 0
            ? Funciones.ordenarListaXCampo(true, producto.escenarios[0].proyecciones, 'anio')[producto.escenarios[0]
                .proyecciones.length - 1].primaAcumulada : null,
        textosLegales: textosLegales !== null
            ? textosLegales.filter(textoLegal => textoLegal.codigoProducto === producto.codigoProducto).map((textoLegal) => {
                return {
                    id: textoLegal.codigoTxtLegal,
                    descripcion: textoLegal.detalleTxtLegal
                }
            }) : undefined
    }

    const [state, setState] = useState(initialState);

    const expandirTabla = () => {
        setState({
            ...state,
            proyecciones: !state.expandido
                ? producto.escenarios[0].proyecciones
                : producto.escenarios[0].proyecciones.filter(proyeccion => (proyeccion.anio === 1 || proyeccion.anio % 5 === 0))
                    .slice(0, Constantes.CANTIDAD_REGISTROS_PROYECCIONES),
            expandido: !state.expandido
        })
    }

    useEffect(() => {
        setState({
            ...state,
            proyecciones: producto.escenarios[0].proyecciones.filter(proyeccion => (proyeccion.anio === 1 || proyeccion.anio % 5 === 0))
                .slice(0, Constantes.CANTIDAD_REGISTROS_PROYECCIONES),
            expandido: false
        })
    }, [producto])

    return (
        <React.Fragment>
            <div className={styles.body}>
                <TituloEscenario
                    titulo='Valores de retorno'
                />
                <TablaProyeccionesAP
                    proyecciones={state.proyecciones}
                    moneda={producto.moneda}
                />
                <TextoDevolucion
                    montoDevolucion={state.montoDevolucion}
                    moneda={producto.moneda}
                />
                <BotonExpandir
                    proyecciones={state.proyecciones}
                    expandido={state.expandido}
                    expandirTabla={expandirTabla}
                    mostrarPoliticaInversion={false}
                />
                <TerminosCondiciones
                    terminosCondiciones={state.textosLegales}
                    esAP={true}
                />
            </div>
        </React.Fragment>
    )
}

export default ProyeccionAP;